import {SubscriptionStore} from '@intelingu/core/stores/SubscriptionStore';
import {computed, observable} from 'mobx';
import {observer} from 'mobx-react';
import * as React from 'react';
import {Component} from 'react';
import {generatePath, Redirect, RouteComponentProps} from 'react-router';
import {components} from 'react-select';
import {SubscriptionsApi} from '@intelingu/core/api/SubscriptionsApi';
import Helpers from '@intelingu/core/helpers/Helpers';
import {ProductModel} from '@intelingu/core/interfaces/models/ProductModel';
import {lazyInject} from '@intelingu/core/IoC/container';
import {CourseStore} from '@intelingu/core/stores/CourseStore';
import {CoursesSelect} from '../../../partials/CoursesSelect';
import {SubscriptionItem} from './SubscriptionItem';
import {COMMON_NS} from "@intelingu/core/constants/base.constants";
import withTranslation from "@intelingu/core/utils/withTranslation";

export interface SubscriptionsPageProps extends RouteComponentProps<{ id?: any }> {
    t?;
}

@withTranslation(COMMON_NS)
@observer export class SubscriptionsPage extends Component<SubscriptionsPageProps, any> {

    @lazyInject(CourseStore) courseStore: CourseStore;
    @lazyInject(SubscriptionStore) subscriptionStore: SubscriptionStore;
    @lazyInject(SubscriptionsApi) subscriptionsApi: SubscriptionsApi;

    @observable _selectedCourseId;
    @observable subscriptions: ProductModel[] = [];

    set courseId(id) {
        this._selectedCourseId = id;
    }

    @computed get courseId() {
        /*if (!this._selectedCourseId && this.props.match.params.id) {
            this._selectedCourseId = Number(this.props.match.params.id);
        }

        return this._selectedCourseId;*/

        return Number(this.props.match.params.id);
    }

    @computed get options() {
        return this.courseStore.coursesList.map(course => ({
            label: course.name,
            code: course.translation_language,
            value: course.id
        }));
    }

    @computed get courseSubscriptions() {
        return this.subscriptions.filter(item => item.course_id === this.courseId);
    }

    customOption = (props) => (
        <components.Option {...props}>
            { this._renderSelectFlag(props) }
            { props.data.label }
        </components.Option>
    );

    singleValue = (props) => (
        <components.SingleValue {...props}>
            { this._renderSelectFlag(props) }
            { props.children }
        </components.SingleValue>
    );

    _renderSelectFlag = (props) => (
        <img
            src={`/assets/images/flags/${props.data.code.toLocaleLowerCase()}.png`}
            alt={props.data.code}
            className={'mr-2'}
            width={17}
        />
    );

    async componentDidMount() {
        const list = await this.subscriptionsApi.getProducts();
        this.subscriptions = Helpers.sortSubscriptions(list.data) as ProductModel[];
    }

    async componentDidUpdate(prevProps: Readonly<SubscriptionsPageProps>, prevState: Readonly<any>, snapshot?: any) {
        this._selectedCourseId = null;
    }

    render() {
        const {
            t,
            match: { params, url, path },
            location: { state }
        } = this.props;

        // redirect to selected or first course if id is not specified
        if (!params.id) {
            const courseId = this.courseStore.currentCourse ?
                this.courseStore.currentCourse.id :
                this.courseStore.coursesList[ 0 ].id;

            return <Redirect to={`${url}/${courseId}`} />
        }

        // update url if user switched course in dropdown
        if (this._selectedCourseId) {
            return <Redirect to={generatePath(path, { id: this._selectedCourseId })} />
        }

        if (!this.courseId) {
            return null;
        }

        return <div className={'subscriptions-page'}>
            { state && state.failed && (
                <div className={'alert alert-danger mb-5'}>
                    { t('subscriptionsPageUnsuccessfulPayment') }
                </div>
            )}

            <div className={'select-wrapper'}>
                <h6>{ t('subscriptionsPageCourseToSubscribe') }</h6>
                {/*<Select
                    options={this.options}
                    components={{ Option: this.customOption, SingleValue: this.singleValue }}
                    value={Helpers.getSelectValue(this.options, this.courseId)}
                    onChange={value => this.courseId = value.value}
                />*/}

                <CoursesSelect
                    defaultValue={this.courseId}
                    onChange={value => this.courseId = value}
                />
            </div>

            <div className={'hr'} />

            <div className={'plans'}>
                { this.courseSubscriptions.filter(item => item.interval > 0).map(item => (
                    <SubscriptionItem item={item} key={item.id} />
                ))}
            </div>
        </div>
    }

}
